import { useMemo } from 'react';
import { useRouter } from 'next/router';
import Head from 'next/head';
import { TextAnswerFragment } from '@graphql/generated/graphql';

type PropsType = {
    pageTitle: string;
    textAnswers: TextAnswerFragment[];
};

const FAQMetaTagHead = ({ pageTitle, textAnswers }: PropsType) => {
    const router = useRouter();

    const structuredData = useMemo(() => {
        const temp = {
            '@context': 'http://schema.org/',
            '@type': 'FAQPage',
            mainEntity: [] as unknown[],
        };

        textAnswers.forEach((question) =>
            temp.mainEntity.push({
                '@type': 'Question',
                name: question?.Title,
                acceptedAnswer: {
                    '@type': 'Answer',
                    text: question?.Answer,
                },
            })
        );

        return temp;
    }, [textAnswers]);

    return (
        <Head>
            {/* Generic */}
            <title>{pageTitle}</title>
            <meta name='title' content={pageTitle} />

            {/* OpenGraph */}
            <meta property='og:title' content={pageTitle} />
            <meta
                property='og:url'
                content={`https://${router.query.company}.pimster.app/${router.query.product}/faq`}
            />
            <meta property='locale' content={router.locale} />

            {/* Twitter */}
            <meta property='twitter:card' content='summary_large_image' />
            <meta
                property='twitter:url'
                content={`https://${router.query.company}.pimster.app/${router.query.product}/faq`}
            />
            <meta property='twitter:title' content={pageTitle} />

            {/* Prevent zoom after input focus on Mozilla */}
            <meta
                name='viewport'
                content='width=device-width, height=device-height, initial-scale=1, minimum-scale=1, maximum-scale=1'
            />

            {/* Structured Data */}
            <script type='application/ld+json'>
                {JSON.stringify(structuredData)}
            </script>
        </Head>
    );
};

export default FAQMetaTagHead;
